'use client';

import { Box } from '@mui/material';
import { styled } from '@mui/system';
interface TagProps {
  label: string;
  state?: 'default' | 'selected' | 'disabled' | 'hover';
  onClick?: () => void;
  ariaLabel?: string;
}
const StyledTag = styled(Box)<{
  state?: 'default' | 'selected' | 'disabled' | 'hover';
}>(({
  theme,
  state
}) => ({
  display: 'flex',
  padding: '8px 12px',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '8px',
  width: 'fit-content',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  textAlign: 'center',
  border: '1px solid',
  transition: 'background 0.3s, color 0.3s, border-color 0.3s',
  cursor: 'pointer',
  ...(state === 'default' && {
    borderColor: theme.palette.neutrals[300],
    color: theme.palette.neutrals[900],
    '&:hover': {
      backgroundColor: theme.palette.secondary[100],
      borderColor: theme.palette.neutrals[300],
      color: theme.palette.neutrals[900]
    }
  }),
  ...(state === 'hover' && {
    backgroundColor: theme.palette.secondary[100],
    borderColor: theme.palette.neutrals[300],
    color: theme.palette.neutrals[900]
  }),
  ...(state === 'selected' && {
    backgroundColor: theme.palette.secondary[100],
    borderColor: theme.palette.secondary[500],
    color: theme.palette.secondary[500]
  }),
  ...(state === 'disabled' && {
    backgroundColor: theme.palette.neutrals[100],
    borderColor: theme.palette.neutrals[300],
    color: theme.palette.neutrals[500],
    cursor: 'not-allowed'
  })
}));
const Tag: React.FC<TagProps> = ({
  label,
  state = 'default',
  onClick,
  ariaLabel
}) => {
  return <StyledTag onClick={state === 'disabled' ? undefined : onClick} state={state} role="button" aria-label={ariaLabel || `${state === 'selected' ? 'Selected: ' : ''}${label}`} aria-pressed={state === 'selected'} aria-disabled={state === 'disabled'} tabIndex={state === 'disabled' ? -1 : 0} data-sentry-element="StyledTag" data-sentry-component="Tag" data-sentry-source-file="Tag.tsx">
			{label}
		</StyledTag>;
};
export default Tag;